import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { LogHelperService } from '../../core/services/log-helper.service';

@Component({
  selector: 'app-generate-po-task-cell-renderer',
  template: `
    <ng-container *ngIf="!params?.data?.parent">
      <span
        (click)="onClick()"
        style="cursor:pointer; font-size:16px; padding: 0 8px;"
        [title]="tooltipText">
        <i class="fa fa-tasks" [style.color]="iconColor"></i>
      </span>
    </ng-container>
  `
})
export class GeneratePOTaskCellRendererComponent implements ICellRendererAngularComp {
  params: any;
  iconColor = 'gray';
  tooltipText = '';

  constructor(private logHelperService: LogHelperService) {}

  agInit(params: any): void {
    this.params = params;
    this.setStatus();
  }

  refresh(params: any): boolean {
    this.params = params;
    this.setStatus();
    return true;
  }

  private setStatus(): void {
    const applicable = this.params.data && this.params.data.HRCApplicable;
    if (!applicable || applicable === 'No') {
      this.iconColor = 'gray';
      this.tooltipText = 'On this work order HRC not applicable.';
    } else {
      this.iconColor = 'green';
      this.tooltipText = 'Generate PO Task';
    }
  }

  onClick(): void {
    const applicable = this.params.data && this.params.data.HRCApplicable;
    if (!applicable || applicable === 'No') {
      this.logHelperService.logError({ message: 'On this work order HRC not applicable.' });
      return;
    }
    // Yes or Partial — delegate to parent component's viewWOTask
    if (this.params.context && this.params.context.componentParent) {
      this.params.context.componentParent.viewWOTask(this.params.data);
    }
  }
}
